import React from 'react'

import {Layout} from '../Components/Layout/Layout'
import {ApiKeyDashboard} from '../Components/ApiKeyDashboard/ApiKeyDashboard'
import {ApiDocumentation} from '../Components/ApiDocumentation/ApiDocumentation'
import {ApiChangelog} from "../Components/ApiChangelog/ApiChangelog";
import {type RouteObject} from "react-router-dom";


const routes: RouteObject[] = [
    {
        path: '/',
        element: <Layout />,
        children: [
            {index: true, element: <ApiKeyDashboard />},
            {path: 'api-docs', element: <ApiDocumentation />},
            {path: 'changelog', element: <ApiChangelog />},
            {path: '*', element: <ApiKeyDashboard />},
        ]
    }
]

export { routes }